<template>
    <v-row>
      <!-- Modal -->
      <v-dialog
        v-model="dialog"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card class="elevation-0 rounded-0 fill-height" color="#F4F6FB">
          <v-toolbar dark elevation="0" class="modal-header-gradient">
            <v-btn icon class="modal-close-btn" @click="dialog = !dialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="font-weight-bold">
              <v-icon left>mdi-bullhorn</v-icon>
              Announcements
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn outlined rounded @click="dialog = !dialog">
                Close
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text class="pa-6">
            <v-container style="max-width: 700px;">
              <v-card
                v-for="(messages, date) in groupedAnnouncements"
                :key="date"
                outlined
                class="mb-4 pa-4"
              >
                <div class="d-flex align-center mb-2">
                  <v-icon color="primary" class="mr-2">mdi-calendar-month</v-icon>
                  <span class="font-weight-bold subtitle-1">{{ date }}</span>
                </div>
                <v-divider class="mb-2"></v-divider>
                <ul class="announcement-list">
                  <li v-for="(message, index) in messages" :key="index">
                    {{ message }}
                  </li>
                </ul>
              </v-card>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </template>
  
  <script>
  export default {
    data() {
      return {
        dialog: true, // Controls modal visibility
        announcementMessages: [
          { date: "2025-07-26", message: "v5.2.0 - Tokens optimised to last longer" },
          { date: "2025-07-20", message: "v5.1.0 - Result module optimised to be faster" },
          { date: "2025-06-01", message: "Welcome to the New MYSCH.NG v5 - New Looks, New Features" },
          { date: "2025-06-01", message: "Say Hello to MYSCH Tokens, a new way to pay for Premium" },
          { date: "2025-05-31", message: "Bye Bye to the Old MYSCH.NG v4 Interface" },
          { date: "2025-03-11", message: "We are having issues with SMS, reach admin to receive codes" },
          { date: "2024-11-06", message: "System maintenance at 5 AM." },
          { date: "2024-11-05", message: "System maintenance at 2 AM." },
          { date: "2024-11-05", message: "Update your profile email address." },
        ],
      };
    },
    computed: {
      groupedAnnouncements() {
        // Helper function to format dates
        function formatDate(dateString) {
          const date = new Date(dateString);
          return date.toLocaleDateString("en-US", {
            weekday: "long", // e.g., "Tuesday"
            year: "numeric", // e.g., "2024"
            month: "long",  // e.g., "November"
            day: "numeric", // e.g., "5"
          });
        }
  
        // Group announcements by formatted date
        const grouped = {};
        this.announcementMessages.forEach((announcement) => {
          const formattedDate = formatDate(announcement.date);
          if (!grouped[formattedDate]) {
            grouped[formattedDate] = [];
          }
          grouped[formattedDate].push(announcement.message);
        });
        return grouped;
      },
    },
  };
  </script>
  
  <style scoped>
  .announcement-list {
    padding-left: 1.2rem;
  }

  .announcement-list li {
    margin-bottom: 0.5rem;
    color: rgba(0, 0, 0, 0.78);
  }
  </style>
  